<template>
  <koyoukeiyaku-menu />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import KoyouKeiyakuMenu from '@/components/koyoukeiyaku/Menu.vue'

export default defineComponent({
  setup() {
    return {}
  },
  components: {
    'koyoukeiyaku-menu': KoyouKeiyakuMenu
  }
})
</script>